var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-basic"},[_c('exact-search',{ref:"exactSearch",attrs:{"state":_vm.state}}),_c('exact-list',{ref:"exactList",attrs:{"state":_vm.state,"table-h":_vm.tableH1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }